<template>
	<div>
		<el-row>
			<el-col :md="24">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item>设备预警</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24" class="warning-main">
				<el-tabs v-model="activeName">
					<el-tab-pane label="报警日志" name="first">
						<crud :fields="fields2" :select="select2" :limits="limits2" apiU="Alarm"></crud>
					</el-tab-pane>
					<el-tab-pane label="预警配置" name="second">
						<crud :fields="fields" :select="select" :limits="limits" apiU="Alarmsetting"></crud>
					</el-tab-pane>
					<el-tab-pane label="短信信息" name="three">
						<el-row>
							<el-col :md="6">
								<div class="card success">
									<div class="card-content">¥ {{ (Number(smsData.amount)/100).toFixed(2) }}<span style="font-size: 14px;">（剩 {{ smsData.smsNum + " 条" }}）</span></div>
									<div class="card-title">账户余额（5 分/条）</div>
								</div>
							</el-col>
							<el-col :md="6">
								<div class="card brand">
									<div class="card-content">¥ {{ (Number(smsData.rechargeSum)/100).toFixed(2) }}</div>
									<div class="card-title">充值总额</div>
								</div>
							</el-col>
							<el-col :md="6">
								<div class="card warning">
									<div class="card-content">{{ smsData.smsLogCount + " 条" }}</div>
									<div class="card-title">发送总数</div>
								</div>
							</el-col>
							<el-col :md="6">
								<div class="card danger">
									<div class="card-content">{{ (smsData.reach*100).toFixed(1) + " %" }}</div>
									<div class="card-title">到 达 率</div>
								</div>
							</el-col>
						</el-row>
						<el-tabs type="border-card">
							<!-- <el-tab-pane label="账户信息">
								<div class="account-div">
									<div class="account-title">账 号 余 额</div>
									<div class="account-money">¥ {{ (Number(smsData.amount)/100).toFixed(2) + " 元" }}</div>
									<div class="account">名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：{{ smsData.name }}</div>
									<div class="account">剩余条数：{{ smsData.smsNum + " 条" }}</div>
									<div class="account">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价：{{ smsData.price + " " + smsData.specification }}</div>
								</div>
							</el-tab-pane> -->
							<el-tab-pane label="短信日志">
								<crud :fields="fields3" :select="[]" :limits="limits3" apiU="Smslog"></crud>
							</el-tab-pane>
							<el-tab-pane label="充值记录">
								<crud :fields="fields4" :select="[]" :limits="limits3" apiU="Recharge"></crud>
							</el-tab-pane>
						</el-tabs>
					</el-tab-pane>
					<!-- <el-tab-pane label="短信配置" name="four">
						
					</el-tab-pane> -->
				</el-tabs>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			var verifyPhone = (rule, value, callback) => {
				const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
				if (!reg.test(value)) {
					callback(new Error('请输入正确的电话号码'));
				}
				else {
					callback();
				}
			};
			return {
				smsData: {
					name: "短信",
					amount: "0",
					smsNum: 0,
					price: "0",
					specification: "分/条",
					"rechargeSum": 0,
					"rechargeCount": 0,
					"smsLogCount": 0,
					"reach": 0
				},
				fields2: [
					{
						name: 'alarmStatus',
						label: '报警状态',
						type: 'select', //text,string,num,image,images,select,selects,address,date,latlong
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [
								{
									label: '正常',
									value: 1
								},
								{
									label: '失败',
									value: 2
								}
							]
						},
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'alarmManner',
						label: '报警方式',
						type: 'select', //text,string,num,image,images,select,selects,address,date,latlong
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [
								{
									label: '打电话',
									value: 1
								},
								{
									label: '发短信',
									value: 2
								}
							]
						},
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'alarmMobileAll',
						label: '报警号码',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'terminalInfo',
						label: '终端信息',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'description',
						label: '描述',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'createTime',
						label: '时间',
						type: 'date',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					}
				],
				select2: [
					{
						name: 'alarmStatus',
						label: '报警状态',
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [
								{
									label: '正常',
									value: 1
								},
								{
									label: '失败',
									value: 2
								}
							]
						}
					},
					{
						name: 'alarmManner',
						label: '报警方式',
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [
								{
									label: '打电话',
									value: 1
								},
								{
									label: '发短信',
									value: 2
								}
							]
						}
					}
				],
				limits2: {
					add: false,
					delete: false,
					edit: false,
					find: true,
					export: false,
					look: true
				},
				fields: [
					{
						name: 'name',
						label: '名称',
						type: 'string',
						rule: [
							{ required: true, message: '请输入名称', trigger: 'blur' }
						],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'alarmMobile',
						label: '电话号码',
						type: 'phone',
						rule: [
							{ required: true, message: '请输入电话号码', trigger: 'blur' },
							{ validator: verifyPhone, trigger: 'blur' }
						],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'yzm',
						label: '验证码',
						type: 'string',
						rule: [
							{ required: true, message: '请输入验证码', trigger: 'blur' }
						],
						limits: {
							look: false,
							add: true,
							edit: false,
							table: false,
							phone: false
						}
					},
					{
						name: 'tacticsAction',
						label: '执行动作',
						type: 'select', //text,string,num,image,images,select,selects,address,date,latlong
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [
								{
									label: '打电话',
									value: 1
								},
								{
									label: '发短信',
									value: 2
								},
								{
									label: '发短信和打电话',
									value: 3
								}
							]
						},
						rule: [
							{ required: true, message: '请选择执行动作', trigger: 'blur' }
						],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'description',
						label: '描述',
						type: 'text',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					}
				],
				select: [],
				limits: {
					add: true,
					delete: true,
					edit: false,
					find: true,
					export: false,
					look: false
				},
				fields3: [
					{
						name: 'name',
						label: '名称',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'mobile',
						label: '电话号码',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'sendTime',
						label: '发送时间',
						type: 'date',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'content',
						label: '发送内容',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'sendStatus',
						label: '发送状态',
						type: 'select', //text,string,num,image,images,select,selects,address,date,latlong
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [
								{
									label: '成功',
									value: 1
								},
								{
									label: '失败',
									value: 2
								}
							]
						},
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					}
				],
				limits3: {
					add: false,
					delete: false,
					edit: false,
					find: true,
					export: true,
					look: false
				},
				fields4: [
					{
						name: 'name',
						label: '名称',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'amount',
						label: '充值金额',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					// {
					// 	name: 'smsNum',
					// 	label: '短信条数',
					// 	type: 'string',
					// 	limits: {
					// 		look: true,
					// 		add: true,
					// 		edit: true,
					// 		table: true,
					// 		phone: true
					// 	}
					// },
					// {
					// 	name: 'price',
					// 	label: '单价',
					// 	type: 'string',
					// 	limits: {
					// 		look: true,
					// 		add: true,
					// 		edit: true,
					// 		table: true,
					// 		phone: true
					// 	}
					// },
					// {
					// 	name: 'specification',
					// 	label: '规格',
					// 	type: 'string',
					// 	limits: {
					// 		look: true,
					// 		add: true,
					// 		edit: true,
					// 		table: true,
					// 		phone: true
					// 	}
					// },
					{
						name: 'rechargeType',
						label: '充值类型',
						type: 'select', //text,string,num,image,images,select,selects,address,date,latlong
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [
								{
									label: '赠送',
									value: 1
								},
								{
									label: '手动充值',
									value: 2
								},
								{
									label: '支付宝',
									value: 3
								},
								{
									label: '微信',
									value: 4
								},
								{
									label: '银行卡',
									value: 5
								}
							]
						},
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'rechargeStatus',
						label: '充值状态',
						type: 'select', //text,string,num,image,images,select,selects,address,date,latlong
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [
								{
									label: '成功',
									value: 1
								},
								{
									label: '失败',
									value: 2
								}
							]
						},
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'createTime',
						label: '充值时间',
						type: 'date',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					}
				],
				activeName: 'first',
				contacts: [
					{
						id: "",
						tacticsAction: "",
						name: "",
						alarmMobile: ""
					},
					{
						id: "",
						tacticsAction: "",
						name: "",
						alarmMobile: ""
					},
					{
						id: "",
						tacticsAction: "",
						name: "",
						alarmMobile: ""
					}
				],
				Alarm: {
					list: [],
					page: {
						current: 0,
						total: 0
					}
				}
			};
		},
		methods: {
			load()
			{
				this.api.Msms.getSmsInfo()
				.then((res)=>{
					if(res.data.code==1)
					{
						this.setdata(this.smsData,res.data.data);
					}
				})
			}
		},
		mounted: function () {
			this.load();
		},
		watch:{
			
		}
	};
</script>

<style scoped>
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	.warning-main{
		/* background-color: white;
		border-radius: 4px; */
	}
	.box-parent{
		padding: 10px;
	}
	.box{
		padding: 20px;
		border: 1px solid #DCDFE6;
		border-radius: 4px;
		background-color: white;
	}
	.title{
		line-height: 40px;
		text-align: center;
		color: #606266;
	}
	.close{
		text-align: right;
	}
	.save{
		text-align: center;
	}
	.card{
		text-align: center;
		border-radius: 10px;
		width: 98%;
		/* max-width: 350px; */
		height: 180px;
		margin: 10px auto;
		padding-top: 50px;
	}
	.card-content{
		font-size: 50px;
		color: white;
		line-height: 60px;
	}
	.card-title{
		font-size: 18px;
		color: #eee;
		margin-top: 30px;
	}
	.brand{
		background-color: #409EFF;
	}
	.success{
		background-color: #67C23A;
	}
	.warning{
		background-color: #E6A23C;
	}
	.danger{
		background-color: #F56C6C;
	}
	.account-div{
		box-shadow: 0px 0px 5px #aaa;
		background-color: white;
		width: 300px;
		padding: 20px;
		border-radius: 5px;
	}
	.account-money{
		font-size: 25px;
		line-height: 30px;
		color: red;
	}
	.account-title{
		font-size: 30px;
		line-height: 40px;
	}
	.account{
		font-size: 20px;
		line-height: 30px;
	}
</style>
